export const CREDIT_LIMIT_FETCH_SUCCESS = 'CREDIT_LIMIT_FETCH_SUCCESS';
export const CREDIT_LINE_FETCH_SUCCESS = 'CREDIT_LINE_FETCH_SUCCESS';
export const CREDIT_LINE_FETCH_ERROR = 'CREDIT_LINE_FETCH_ERROR';
export const FC_LEAD_FETCH_SUCCESS = 'FC_LEAD_FETCH_SUCCESS';
export const FC_PAYMENT_FETCH_SUCCESS = 'FC_PAYMENT_FETCH_SUCCESS';
export const SET_RCL_NOTIFICATION = 'SET_RCL_NOTIFICATION';



// WEBPACK FOOTER //
// ./src/features/CreditLimit/actionTypes.js